"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultRules = exports.BoldRule = exports.createDynamicHighlightingRule = exports.HighlightRule = exports.LinebreakRule = void 0;
const PT = __importStar(require("prop-types"));
const React = __importStar(require("react"));
const textparser_1 = require("@navikt/textparser");
const rules_1 = require("./rules");
var textparser_2 = require("@navikt/textparser");
Object.defineProperty(exports, "LinebreakRule", { enumerable: true, get: function () { return textparser_2.LinebreakRule; } });
Object.defineProperty(exports, "HighlightRule", { enumerable: true, get: function () { return textparser_2.HighlightRule; } });
Object.defineProperty(exports, "createDynamicHighlightingRule", { enumerable: true, get: function () { return textparser_2.createDynamicHighlightingRule; } });
Object.defineProperty(exports, "BoldRule", { enumerable: true, get: function () { return textparser_2.BoldRule; } });
__exportStar(require("./rules"), exports);
exports.defaultRules = [rules_1.LinkRule, textparser_1.LinebreakRule, rules_1.ParagraphRule];
class Tekstomrade extends React.Component {
    render() {
        const _a = this.props, { as, children, ingenFormattering, rules } = _a, rest = __rest(_a, ["as", "children", "ingenFormattering", "rules"]);
        if (typeof children !== "string") {
            return null;
        }
        if (ingenFormattering) {
            return React.createElement("div", Object.assign({}, rest), children);
        }
        const ast = (0, textparser_1.parse)(children, rules);
        const content = (0, textparser_1.build)(ast, rules);
        return React.createElement(as, rest, content);
    }
}
Tekstomrade.defaultProps = {
    as: "div",
    ingenFormattering: false,
    rules: exports.defaultRules,
};
Tekstomrade.propTypes = {
    as: PT.oneOfType([PT.string, PT.elementType]).isRequired,
    children: PT.string.isRequired,
    ingenFormattering: PT.bool.isRequired,
    rules: PT.arrayOf(PT.shape({
        name: PT.string.isRequired,
        scope: PT.number.isRequired,
        regex: PT.object.isRequired,
        parse: PT.func.isRequired,
        react: PT.func.isRequired,
    })).isRequired,
};
exports.default = Tekstomrade;
